/**
 * token
 */
export const ACCESS_TOKEN = getEnvWords("DM-Access-Token");

/**
 * 登录
 */
export const LOGIN_INFO = getEnvWords('DM-Login-Info');


/**
 * 根据不同环境得到不同的值
 */
function getEnvWords(key) {
  return process.env.VUE_APP_API_ENV === "prod"
    ? key
    : process.env.VUE_APP_API_ENV + "-" + key;
}
